import { render, staticRenderFns } from "./IdVerification.vue?vue&type=template&id=63e3cc52&scoped=true"
import script from "./IdVerification.vue?vue&type=script&lang=js"
export * from "./IdVerification.vue?vue&type=script&lang=js"
import style0 from "./IdVerification.vue?vue&type=style&index=0&id=63e3cc52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e3cc52",
  null
  
)

export default component.exports